import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "shortcut", "icon", "disabled", "isFirstItem", "indentContent"];
import React from "react";
import Content from "../Content";
import { BaseDropdownMenuItem } from "../DropdownMenuItem/styled";
import { jsx as _jsx } from "react/jsx-runtime";
function DropdownMenuLinkItem(_ref) {
  var label = _ref.label,
    shortcut = _ref.shortcut,
    icon = _ref.icon,
    disabled = _ref.disabled,
    isFirstItem = _ref.isFirstItem,
    indentContent = _ref.indentContent,
    linkProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseDropdownMenuItem, {
    asChild: true,
    disabled: disabled,
    indentContent: indentContent,
    htmlTag: "a",
    children: /*#__PURE__*/_jsx("a", _extends({
      role: "menuitem"
    }, linkProps, {
      children: /*#__PURE__*/_jsx(Content, {
        icon: icon,
        label: label,
        shortcut: shortcut
      })
    }))
  });
}
export default DropdownMenuLinkItem;